import type { LookupUser, LookupUsers } from '@atlassian/ui-modifications-core/types';
import { FieldValueLookupError } from '@atlassian/ui-modifications-core/utils';
import type {
	ReporterPublicGetValue,
	ReporterPublicSetValue,
} from '@atlassian/jira-ui-modifications-common/src/common/utils/common/fields/reporter.tsx';
import { singleValueLookup } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/single-value-lookup/index.tsx';

export type ReporterInternalValue = null | {
	id: string;
	name: string;
	avatarUrl: string;
};

export const reporterSetValueTransformer = (
	value: ReporterPublicSetValue,
	lookupValues?: LookupUsers,
): ReporterInternalValue => {
	if (value === null) {
		return null;
	}

	const foundValue = singleValueLookup<LookupUser>(value, lookupValues, 'accountId');

	if (!foundValue) {
		throw new FieldValueLookupError();
	}

	return {
		id: foundValue.accountId,
		name: foundValue.name,
		avatarUrl: foundValue.picture,
	};
};

export const reporterGetValueTransformer = (
	value: ReporterInternalValue,
): ReporterPublicGetValue => {
	if (!value) {
		return null;
	}

	const { id: accountId } = value;
	return { accountId };
};
